import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const certificationCourses = {
    major: {
        queryList: config => createAPI('/skillRecognition/kzkc/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/kzkc/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/kzkc/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/kzkc/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/kzkc/releaseRecById', 'post', config),
    },
};

export default certificationCourses;



// WEBPACK FOOTER //
// ./src/api/modules/certificationCourses.js